"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiPdfBillRepo = createApiPdfBillRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
const PdfBillMapper_1 = require("./mappers/PdfBillMapper");
function createApiPdfBillRepo() {
    return {
        getById,
    };
}
async function getById(orderId) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/bills/summary/${orderId}`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        const mappedRes = res.map(PdfBillMapper_1.mapToDomainPdfBill);
        return res.map(PdfBillMapper_1.mapToDomainPdfBill);
    }
    catch (error) {
        console.log('error', error);
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
